import styled from 'styled-components'

import React from 'react'

const Select = ({ icon, value, onChangeFunction, title, id, options, placeholder }) => {
  return (
    <S_SelectContainer>
      <S_IconContainer>
        <S_Icon className={'fas fa-' + icon} />
      </S_IconContainer>
      
      <S_Select 
        value={value} 
        onChange={onChangeFunction} 
        title={title}
        id={id}
      >
        {
          placeholder 
            ? <S_Option disabled>{ placeholder }</S_Option> 
            : null
        }
        {
          options.map((option, index) => <S_Option key={index + option} value={option}>{option}</S_Option>)
        } 
      </S_Select>
    </S_SelectContainer>
  )
}

export default Select

const S_IconContainer = styled.div`
  display: flex;
  align-items: center;
  /* background: var(--Surface); */
  border-radius: 8px 0 0 8px;
  height: 100%;
  padding-left: 8px;
`

const S_Icon = styled.i`
  display: flex;
  color: var(--Font_Color);
  font-size: var(--Font_Size_Icon_Small);
  text-align: center;
  vertical-align: center;
  height: 100%;
  position:relative;
  top: calc(50% - 10px);

`

const S_SelectContainer = styled.div`
  display: flex;
  align-items: center;
  height: var(--Input_Height);
  border-radius: 8px;
  overflow: hidden;
  /* background: var(--Surface_1); */
  box-shadow: var(--Outline);

  * {
    margin: 0;
    display: inline-block;
    vertical-align: middle;
  }

  transition: 0s;
  &:hover {
    background: var(--Surface_1);
  }
  &:active {
    background: var(--Primary_Variant);
    
  }
  &:focus {
    background: var(--Primary_Variant);
  }
`

const S_Select = styled.select`
  display: flex;
  width: 100%;
  font-size: var(--Font_Size);
  padding-left: 6px;
  cursor: pointer;
  background: none;
  /* text-align: center; */
  border: none;
  color: var(--Font_Color);
  height: 100%;
  /* background: var(--Surface); */
`

const S_Option = styled.option`
  /* background: #2B2B2B; */
  color: var(--Font_Color);
`